export enum ProposalStatus {
  Draft = 'draft',
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
  Stale = 'stale',
  Withdrawn = 'withdrawn',
  /** Terminal state for resolved proposals. */
  Closed = 'closed',
}

export enum NotificationKind {
  ProposalSubmitted = 'proposal_submitted',
  ProposalUpdated = 'proposal_updated',
  ProposalApproved = 'proposal_approved',
  /** The approved proposal's changes were applied to the live action by the
   *  admin. Distinct from `ProposalApproved` (which just records the decision). */
  ProposalApplied = 'proposal_applied',
  ProposalRejected = 'proposal_rejected',
  ProposalRemoved = 'proposal_removed',
  ProposalStale = 'proposal_stale',
  /** One side closed a resolved proposal — the other side gets notified and
   *  has to dismiss to fully close it. */
  ProposalClosed = 'proposal_closed',
  CommentAdded = 'comment_added',
  /** A message landed in the per-campaign general chat (outreach chat). */
  ChatMessage = 'chat_message',
  /** A client created a campaign through the builder. Attributed to the company, not a user. */
  CampaignSubmitted = 'campaign_submitted',
}

export type NotificationRecipientRole = 'admin' | 'client';

export interface AppNotification {
  id: string;
  recipientUserSub: string | null;
  recipientRole: NotificationRecipientRole | null;
  /** User who caused the notification (commenter, approver, etc.). */
  actorUserSub: string | null;
  actorName: string | null;
  /** Company the event belongs to. Internal viewers only — null for clients. */
  companyName: string | null;
  kind: NotificationKind;
  title: string;
  body: string;
  refType: string;
  refId: string;
  /** Raw campaign type; set only on campaign events. */
  campaignType: string | null;
  link: string | null;
  read: boolean;
  createdAt: string;
}

export const LS_KEYS = {
  notifications: 'aktify_notifications_v1',
  acks: 'aktify_proposal_acks_v1',
} as const;
